<div class="progress-bar">
  <div class="progress-bar-inner" [style]="{ width: progress + '%' }"></div>
</div>
<div class="progress-legend mt-2">
  <div class="progress-legend-bar"></div>
  <div class="progress-legend-values d-flex justify-content-between">
    <span class="progress-legend-min">{{ min | number }}</span>
    <span class="progress-legend-max">{{ currency?.symbol }}{{ max | number }}</span>
  </div>
</div>
